import React from "react";
import DataSection from "../components/sections/Data.jsx";
import { data } from "../constants/webtekno/data.js";
import SliderSection from "../components/sections/Slider.jsx";
import { projeler } from "../constants/webtekno/projeler.js";
import { useLanguage } from "../contexts/LanguageContext";

export default function Webtekno() {
  const { language } = useLanguage();

  return (
    <div className="flex flex-col">
      <img
        src={
          language === "TR"
            ? "https://srv-cdn.onedio.com/store/32753c48feb5347665a21a7cc35849e76f656e4558c0bc7ca58c67bd8eadfec7.jpg"
            : "https://srv-cdn.onedio.com/store/f1d64c0459f75100fccb826ffbb3cbea1f58f4785882ce5f691b1f57a0927842.jpg"
        }
        className="w-full max-w-[1440px] mx-auto"
      />
      <DataSection data={data} title="Datalar" name="datalar" />
      <SliderSection
        className={"bg-[#FEF9F3]"}
        data={projeler}
        circle={false}
        name="projeler"
      />
    </div>
  );
}
